import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ArrowRight } from "lucide-react";

const Generatedkundli = ({ userId, dob, tob, lat, lon, div = "D1", style = "north", color = "#ff3366" }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId || !dob || !tob || !lat || !lon) return;
    const fetchKundli = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch("/api/user/chart-image", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId,
            dob,
            tob,
            lat,
            lon,
            div,
            style,
            color
          }),
        });
        if (!response.ok) throw new Error("Failed to fetch kundli image");
        const data = await response.json();
        setImageUrl(data?.data?.image_url || null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchKundli();
  }, [userId, dob, tob, lat, lon, div, style, color]);

  return (
    <div className="flex flex-col justify-start items-center min-h-[400px] bg-[#F8F8F8] border border-[#F05A22] border-opacity-20 w-full rounded-xl p-4">
      <div className="flex justify-between items-center bg-white py-4 px-4 w-full rounded-t-xl">
        <h2 className="font-semibold">Generated Kundli</h2>
        <div className="flex items-center space-x-2 text-[#F05A22] cursor-pointer">
          <p className="text-sm font-semibold">View Full Kundli</p>
          <ArrowRight size={20} />
        </div>
      </div>
      <div className="flex-1 w-full flex flex-col items-center justify-center p-6">
        {loading && <div className="text-center text-gray-500">Generating Kundli...</div>}
        {error && <div className="text-red-500">{error}</div>}
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Kundli Chart"
            className="max-w-[350px] max-h-[350px] rounded shadow-md border border-gray-200"
          />
        )}
        {!loading && !imageUrl && !error && (
          <div className="text-gray-400">Kundli image will appear here after submission.</div>
        )}
      </div>
    </div>
  );
};

export default Generatedkundli;
